module.exports = __webpack_public_path__ + "static/saws-new-298409a2b717204567f701b0858598ca.jpg";